import * as yup from "yup";

declare module "yup" {
    export interface StringSchema {
        /**
        * Check for name validity.
        *       
        * @param {Boolean} [required=false] Is name required.
        * @param {String} [errorMessage=DEFAULT_MESSAGE] The error message to return if the validation fails.
        * @param {Boolean} [excludeEmptyString=false] Should be trimmed before validation
        */
        guid(
            required: boolean,
            errorMessage?: string,
            excludeEmptyString?: boolean,
        ): StringSchema;
    }
}
const YUP_NAME_METHOD = "guid";
const guidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

yup.addMethod(yup.string, YUP_NAME_METHOD, function yupGuid(
    required: boolean,
    errorMessage: string = "",
    excludeEmptyString: boolean = false
) {
    const errMsg =
        typeof errorMessage === "string" && errorMessage
            ? errorMessage
            : "Guid is required.";

    return this.test(YUP_NAME_METHOD, errMsg, (value: string) => {
        if (!value) {
            return !required;
        }
        if (excludeEmptyString) {
            value = value.trim();
        }

        return guidRegex.test(value);
    });
});